/**
 * @author        yontaek@zumper.com (Yon Taek Chung)
 * @copyright     Copyright (c) 2020, Zumper
 * @description   useMount
 */

import { useEffect } from 'react'

export const useMount = (callback?: () => void) => {
  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    if (callback) {
      callback()
    }
  }, [])
}
